import * as React from 'react';
import { Query } from 'react-apollo';
import { findMatchingRecord } from 'utils/arrayHelpers';
import GROUPS_COUNT_QUERY from './queries/OrgGroupsCountQuery.gql';

import {
  OrgGroupsCountQuery,
  OrgGroupsCountQueryVariables,
  OrgGroupsCountQuery_organizations,
} from './queries/__generated__/OrgGroupsCountQuery';

import { ListActionsFilterState } from 'components/ListActions/ListActions';
import GroupListFilterView from 'groups/components/GroupList/GroupListFilterView';

import 'components/PeopleList/styles/PeopleListFilterUIDataContainer.scss';

export type Props = {
  filters: ListActionsFilterState;
  onFiltersChange: (activeFilters: ListActionsFilterState) => void;
  onQueryChange: (query: string) => void;
  onQueryClick?: () => void;
  orgUuid: string;
  query: string | null;
};

class GroupListFilterContainer extends React.Component<Props> {
  render() {
    const { onFiltersChange, onQueryChange, onQueryClick, filters, orgUuid, query } = this.props;

    return (
      <Query<OrgGroupsCountQuery, OrgGroupsCountQueryVariables>
        query={GROUPS_COUNT_QUERY}
        variables={{
          orgUuid,
          q: query,
        }}
        fetchPolicy="network-only">
        {({ data, error }) => {
          if (error || !data) {
            console.error(
              'GroupListFilterContainer - could not load organization with group counts'
            );
          }

          const org =
            data &&
            findMatchingRecord<OrgGroupsCountQuery_organizations>(data.organizations, orgUuid);

          const activeCount = org ? org.activeGroupCount : -1;
          const unclaimedCount = org ? org.unclaimedGroupCount : -1;

          return (
            <GroupListFilterView
              data-test="group-list-filter-view"
              filters={filters}
              onFiltersChange={onFiltersChange}
              onQueryChange={onQueryChange}
              onQueryClick={onQueryClick}
              activeCount={activeCount}
              unclaimedCount={unclaimedCount}
            />
          );
        }}
      </Query>
    );
  }
}

export default GroupListFilterContainer;
